import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface CmsState {
  [key: string]: any;
}

const initialState: CmsState = {
  isLoggedIn: true,
};

const cmsSlice = createSlice({
  name: "cms",
  initialState,
  reducers: {
    setCms: (state, action: PayloadAction<{ type: string; data: any }>) => {
      state[action.payload.type] = action.payload.data;
    },
    resetCms: (state, action: PayloadAction<{ type: string }>) => {
      state[action.payload.type] = undefined;
    },
    setNestedCms: (
      state,
      action: PayloadAction<{ type: string; nestedKey: string; data: any }>
    ) => {
      if (state[action.payload.type]) {
        state[action.payload.type][action.payload.nestedKey] =
          action.payload.data;
      } else {
        state[action.payload.type] = {};
        state[action.payload.type][action.payload.nestedKey] =
          action.payload.data;
      }
    },
  },
});

export const cmsActions = cmsSlice.actions;

export default cmsSlice.reducer;
